import type { Dispatch } from "react";

import { useTranslation } from "@/lib/i18n";
import { EditableLabel } from "@/features/widget-forms/forms/weather-model-map/components/editable-label";
import DraggableCard, {
  configItemCardStyles,
} from "@/features/widget-forms/forms/weather-model-map/components/draggable-card/draggable-card";
import { fmtSubtitle } from "@/features/widget-forms/forms/weather-model-map/modals/map-layer-formatters";
import type {
  ModelMapParameterMapLayerConfiguration,
  ParametersAbstractMapLayer,
} from "@/lib/api";

interface MapLayerCardProps {
  mapLayer: ModelMapParameterMapLayerConfiguration;
  layerInfo?: ParametersAbstractMapLayer;
  onRename: Dispatch<string>;
  onRemove: () => void;
}

function MapLayerCard({ mapLayer, layerInfo, onRename, onRemove }: MapLayerCardProps) {
  const { t } = useTranslation();
  const zoomLevels = layerInfo ? fmtSubtitle(layerInfo.zoom_levels) : "";
  const originalTitle = layerInfo?.label;
  const subtitle = [originalTitle, zoomLevels].filter(Boolean).join(" · ");

  return (
    <DraggableCard
      onRemove={onRemove}
      removeLabel={t("admin.widgets.fields.model_map.general.remove_item", {
        item: mapLayer.label,
      })}
    >
      <div className={configItemCardStyles.titleGroup}>
        <div className={configItemCardStyles.title}>
          <EditableLabel
            value={mapLayer.label}
            onValueChange={onRename}
            placeholder={originalTitle}
          />
        </div>
        {subtitle && <div className={configItemCardStyles.subtitle}>{subtitle}</div>}
      </div>
    </DraggableCard>
  );
}

export default MapLayerCard;
